import gql from 'graphql-tag';

export const CREATE_OTHER_ASSET_MUTATION = gql`
  mutation createOtherAsset($otherAssetInputDetails: OtherAssetInput!) {
    createOtherAsset(otherAssetInput: $otherAssetInputDetails) {
      id
      testatorId
      description
      displayName
      specificDonation {
        id
      }
    }
  }
`;

export const UPDATE_OTHER_ASSET_MUTATION = gql`
  mutation updateOtherAsset(
    $id: ID!
    $otherAssetInputDetails: OtherAssetInput!
  ) {
    updateOtherAsset(id: $id, otherAssetInput: $otherAssetInputDetails) {
      id
      testatorId
      description
      displayName
      specificDonation {
        id
      }
    }
  }
`;

export const DELETE_OTHER_ASSET_MUTATION = gql`
  mutation deleteOtherAsset($id: ID!) {
    deleteOtherAsset(id: $id) {
      id
    }
  }
`;
